import { render, staticRenderFns } from "./VendasOffline.vue?vue&type=template&id=2363aedc&scoped=true"
import script from "./VendasOffline.vue?vue&type=script&lang=js"
export * from "./VendasOffline.vue?vue&type=script&lang=js"
import style0 from "./VendasOffline.vue?vue&type=style&index=0&id=2363aedc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2363aedc",
  null
  
)

export default component.exports